// Dark/light mode — the toggle button existed as a UI placeholder with no
// logic behind it at all (no state, no onClick, nothing ever adding the
// `dark` class Tailwind's `darkMode: 'class'` config depends on). This is
// the actual implementation: persisted in localStorage, applied to
// <html> so every `dark:` utility class already used throughout the app
// starts working.

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'theme';

export function getStoredTheme(): Theme {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch {
        // localStorage unavailable (e.g. privacy mode) — fall through to OS preference
    }
    const prefersDark = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
}

function applyTheme(theme: Theme) {
    document.documentElement.classList.toggle('dark', theme === 'dark');
}

// Call once, as early as possible (before the first paint) to avoid a
// flash of the wrong theme on load.
export function initTheme(): Theme {
    const theme = getStoredTheme();
    applyTheme(theme);
    return theme;
}

export function persistTheme(theme: Theme) {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
    applyTheme(theme);
}
